import React from 'react';
import PropTypes from 'prop-types';
import TweenOne, { TweenOneGroup } from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';

class Content extends React.Component {

  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
  };

  static defaultProps = {
    className: 'content4',
  };

  getChildrenToRender = (item, i) => {
    const id = `block${i}`;
    return (<li
      key={i}
      id={`${this.props.id}-${id}`}
    >
      <div className="content-wrapper">
        <span><img src={item.img} height="100%" /></span>
        <p>{item.content}</p>
      </div>
    </li>);
  }

  getEnterAnim = (e, isMode) => {
    const index = e.index;
    const delay = isMode ? index * 50 + 200 : index % 4 * 100 + Math.floor(index / 4) * 100 + 300;
    return { y: '+=30', opacity: 0, type: 'from', delay };
  };

  render() {
    const props = { ...this.props };
    const isMode = props.isMode;
    delete props.isMode;
    const dataArray = [
      { img: 'http://www.hooyee.xyz/images/huayehw.png', content: '中央国家机关户外运动协会\nhttp://www.huayehw.com' },
      { img: 'http://www.hooyee.xyz/images/tenneco.png', content: '天纳克（中国）亚太地区总部\nhttp://www.tenneco.cn ' },
      { img: 'http://www.hooyee.xyz/images/gongli.png', content: '上海恭立机电发展有限公司\nhttp://www.gonglielec.com' },
      { img: 'http://www.hooyee.xyz/images/longfa.png', content: '龙口市龙发汽车玻璃有限公司\nhttp://www.longfaboli.com' },
      { img: 'http://www.hooyee.xyz/images/kp.png', content: '陕西科鹏实业有限公司\nhttp://www.shaanxikepeng.com' },
      { img: 'http://www.hooyee.xyz/images/aliyun.png', content: 'Ant Motion' },
      { img: 'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg', content: 'Ant Design' },
      { img: 'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg', content: 'Ant Motion' },
    ];
    const childrenToRender = dataArray.map(this.getChildrenToRender);
    return (
      <div
        {...props}
        className="content-template-wrapper content4-wrapper"
      >
        <OverPack
          className={`content-template ${props.className}`}
          id="customer"
        >
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from', ease: 'easeOutQuad' }}
            component="h1"
            key="h1"
            reverseDelay={300}
            id={`${props.id}-title`}
          >
            案例客户与合作伙伴
          </TweenOne>
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from', delay: 200, ease: 'easeOutQuad' }}
            component="p"
            key="p"
            reverseDelay={200}
            id={`${props.id}-content`}
          >
            一次牵手，合作永久
          </TweenOne>
          <TweenOneGroup
            className={`${props.className}-img-wrapper`}
            component="ul"
            key="ul"
            enter={(e) => {
              return this.getEnterAnim(e, isMode)
            }}
            leave={{ y: '+=30', opacity: 0, ease: 'easeOutQuad' }}
            id={`${props.id}-ul`}
          >
            {childrenToRender}
          </TweenOneGroup>
        </OverPack>
      </div>
    );
  }
}


export default Content;



// WEBPACK FOOTER //
// ./src/Home/Content2.jsx